<div class="modal-header">
  <h5 class="modal-title">
    {{ product.name }} : 
    <fa-icon class="me-2" [icon]="faTractor"></fa-icon>
    <a [routerLink]="['/admin-farm-profile', product.farmID]" class="invisible-button" (click)="closeModal()">
      {{ product.farmName }}
    </a>
  </h5>   
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <p>{{ product.description }}</p>
    
    <div class="review-section">
      <div class="d-flex align-items-center mb-2">
        <h6 class="mb-0 me-2">Podaj oceno:</h6>
        <star-rating 
          [starType]="'svg'" 
          [rating]="newReview.rating" 
          (ratingChange)="onRatingChange($event)">
        </star-rating>
      </div>
      <form (submit)="submitReview()">
        <div class="form-group">
          <textarea class="form-control" [(ngModel)]="newReview.comment" name="reviewText" rows="3" required placeholder="Podajte vaš komentar tukaj..." ></textarea>
        </div>
        <button type="submit" class="btn btn-sm rounded-pill mt-2 mb-2" style="background-color: #53AD4B; color: white;">Pošlji</button>
      </form>
    </div>
    
    <div *ngFor="let review of product.reviews" class="review-item">
      <div>
        <p class="mb-1">
          <fa-icon class="me-2 fa-lg" [icon]="faUser"></fa-icon><strong>{{ review.username || 'Loading...' }}:</strong> {{ review.comment }}
        </p>
        <p>
          <span class="text-muted small ms-2">{{ review.timestamp | date: 'mediumDate' }}</span>
        </p>
        <div class="d-flex">
          <star-rating 
            [starType]="'svg'" 
            [rating]="review.rating"
            [readOnly]="true">
          </star-rating>
        </div>
      </div>
    </div>    
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Zapri</button>
  </div>
  